import React from "react";
import { Box, SxProps, Theme } from "@mui/material";

interface CircularOverlayProps {
  sx?: SxProps<Theme>;
}

/**
 * CircularOverlay Component
 *
 * A decorative SVG circle overlay for profile avatars.
 * Matches the design from the existing codebase with seaweed and light grey colors.
 */
const CircularOverlay: React.FC<CircularOverlayProps> = ({ sx }) => {
  return (
    <Box
      component="svg"
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "110%",
        height: "110%",
        zIndex: 1,
        pointerEvents: "none",
        ...sx,
      }}
      width="146.222"
      height="147.012"
      viewBox="0 0 146.222 147.012"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            width="146.222"
            height="147.012"
            fill="none"
            stroke="#fff"
            strokeLinecap="round"
            strokeWidth="1"
          />
        </clipPath>
      </defs>
      <g transform="translate(6.687 6.723)">
        <g transform="translate(-6.687 -6.723)" clipPath="url(#clip-path)">
          <path
            d="M115.563,157.714A60.462,60.462,0,0,1,7.577,106.4"
            transform="translate(7.668 -50.809)"
            fill="none"
            stroke="#b2d7d3"
            strokeLinecap="round"
            strokeWidth="6"
          />
          <path
            d="M64.968,16.2a60.449,60.449,0,0,1,95.5,49.244"
            transform="translate(-26.913 7.668)"
            fill="none"
            stroke="#f5f5f5"
            strokeLinecap="round"
            strokeWidth="6"
          />
        </g>
      </g>
    </Box>
  );
};

export default CircularOverlay;
